import { FC } from 'react';

const UseMobileApp: FC = () => (
  <section className='h-[100vh] w-100 flex items-center'>
    <h1 className='text-center text-3xl'>Please open the mobile application or contact 
      {' '}
      <a 
        className='text-blue-600 hover:text-blue-800 visited:text-purple-600' 
        href='mailto:app.ces@omya.com'>
      app.ces@omya.com
      </a> 
      {' '}
      to get access to the application</h1>
  </section>
);

export default UseMobileApp;